<template>
  <div class="triger-container">
    <div class="triger">
      <p class="title">{{title}}</p>
      <div class="slects">
        <el-form :model="localForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
          <div class="slect-top">
            <el-select @change="conditionChange" v-model="form.params.conditionType" placeholder="请选择执行条件">
              <el-option
                v-for="item in options1"
                :key="item.value"
                value-format="yyyy-MM-dd"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-form-item v-if="form.params.conditionType==='2'" label="" prop="mount">
              <el-date-picker
                value-format="yyyy-MM-dd"
                v-model="form.params.beginDate"
                type="date"
                placeholder="请选择起始时间">
              </el-date-picker>
              <!-- <el-input v-model="localForm.beginDate"
                        placeholder="请输入起始时间"></el-input> -->
            </el-form-item>
            <el-form-item v-if="form.params.conditionType==='2'" label="" prop="mount">
              <el-date-picker
                v-model="form.params.endDate"
                type="date"
                placeholder="请选择结束时间">
              </el-date-picker>
              <!-- <el-input v-model="localForm.endDate"
                        placeholder="请输入结束时间"></el-input> -->
            </el-form-item>
            <el-select
              @change="productTypeChange"
              :disabled="!form.params.conditionType"
              v-if="form.params.conditionType==='1'"
              v-model="form.params.productKey"
              placeholder="请选择设备类型">
              <el-option
                v-for="(item, index) in options2"
                :key="index"
                :label="item.productName"
                :value="item.productKey">
              </el-option>
            </el-select>
            <el-select
              @change="productChange"
              :disabled="!form.params.productKey"
              v-if="form.params.conditionType==='1'"
              v-model="form.params.deviceName"
              placeholder="请选择设备">
              <el-option
                v-for="(item, index) in options3"
                :key="index"
                :label="item.deviceName"
                :value="item.deviceName">
              </el-option>
            </el-select>
          </div>
          <div
            class="select-bottom"
            v-if="form.params.conditionType==='1'">
            <el-select
              @change="propChange"
              :disabled="!form.params.deviceName"
              v-model="form.params.propertyName"
              placeholder="请选择属性">
              <el-option
                v-for="item in options4"
                :key="item.identifier"
                :label="item.name"
                :value="item.identifier">
              </el-option>
            </el-select>
            <el-select
              @change="compareChange"
              :disabled="!form.params.propertyName"
              v-model="form.params.compareType"
              placeholder="请选择比较模式">
              <el-option
                v-for="item in options5"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-select
              v-if="this.compareType===0"
              @change="inputChange"
              :disabled="!form.params.compareType"
              v-model="localForm.compareValue"
              placeholder="请选择比较值">
              <el-option
                v-for="item in options6"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-form-item  v-if="this.compareType===1" label="" prop="compareValue">
              <el-input
                @input="inputChange"
                :disabled="!form.params.compareType"
                v-model="localForm.compareValue"
                placeholder="请输入数值">
              </el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
    <el-button
      type="text"
      @click="deleteItem">
      删除
    </el-button>
  </div>
</template>

<script>
import { deviceList, getProductProp } from '@/api/ruleEngine.js'
// eslint-disable-next-line no-unused-vars
let compareRange = {}
let compareValue = '='
const validatePass = function (rule, value, callback) {
  if (compareValue === 'in') {
    let arr = []
    try {
      arr = JSON.parse(value)
    } catch (e) {
      callback(new Error('例如输入[1,2,3,4]'))
      return
    }
    if (!Array.isArray(arr)) {
      callback(new Error('例如输入[1,2,3,4]'))
    } else {
      for (const item in arr) {
        if (item > compareRange.max || item < compareRange.min) {
          callback(new Error('超过限定数字范围'))
          break
        }
      }
    }
  } else if (compareValue === 'between') {
    let arr = []
    try {
      arr = JSON.parse(value)
    } catch (e) {
      callback(new Error('例如输入[1,4]'))
      return
    }
    if (!Array.isArray(arr)) {
      callback(new Error('例如输入[1,4]'))
    } else {
      for (const item in arr) {
        if (item > compareRange.max || item < compareRange.min) {
          callback(new Error('超过限定数字范围'))
          break
        }
      }
    }
  } else {
    var value1 = parseFloat(value)
    if (value1 > compareRange.max || value1 < compareRange.min) {
      callback(new Error('超过限定数字范围'))
    }
    callback()
  }
}
export default {
  name: 'conditionItem',
  data () {
    return {
      compareType: 0,
      propInfo: {},
      rules: {
        compareValue: [
          {
            required: true,
            message: '请输入数值',
            trigger: 'blur'
          },
          {
            validator: validatePass,
            trigger: 'blur'
          }
        ]
      },
      localForm: { mount: '', compareValue: '' },
      options1: [{
        value: '1',
        label: '设备状态'
      }, {
        value: '2',
        label: '时间范围'
      }],
      options2: [],
      options3: [],
      options4: [],
      options5: [],
      options6: [],
      value1: '',
      value2: '',
      value3: '',
      value4: '',
      value5: '',
      value6: '',
      value7: ''
    }
  },
  props: {
    itemIndex: {
      type: Number
    },
    title: {
      type: String,
      default: '执行条件'
    },
    form: {
      type: Object
    },
    productList: {
      type: Array
    }
  },
  watch: {
    form: {
      handler (value) {
        if (!value.params.productKey) return
        this.localForm.compareValue = value.params.compareValue
        compareValue = value.params.compareType
        deviceList({ productKey: value.params.productKey }).then(res => {
          this.options3 = res.data
        })
        getProductProp({ productKey: value.params.productKey }).then(res => {
          this.propData = res.data.thingModel
          if (value.params.conditionType === '1') {
            this.options4 = this.propData.properties
            const propertyItem = this.options4.filter(item => {
              return item.identifier === this.form.params.propertyName
            })[0]
            if (propertyItem.dataType.type === 'bool' || propertyItem.dataType.type === 'enum') {
              this.options5 = [{
                value: '=='
              }]
              const specs = propertyItem.dataType.specs
              const keys = Object.keys(specs)
              this.options6 = keys.map(index => {
                return {
                  label: specs[index],
                  value: index
                }
              })
              this.compareType = 0
            } else {
              this.options5 = [{
                value: '>'
              }, {
                value: '>='
              }, {
                value: '<='
              }, {
                value: '!='
              }, {
                value: '=='
              }, {
                value: 'in'
              }, {
                value: 'between'
              }]
              this.compareType = 1
              compareRange = propertyItem.dataType.specs
            }
          } else if (value.params.conditionType === '2') {
            this.options5 = this.propData.events
          } else {
            this.options5 = [{
              identifier: '1',
              name: '下线'
            }, {
              identifier: '2',
              name: '上线'
            }]
          }
        })
      },
      immediate: true
    },
    productList: {
      handler (value) {
        this.options2 = value
      },
      immediate: true
    }
  },
  methods: {
    conditionChange (value) {
      this.form.params.productKey = ''
      this.form.params.deviceName = ''
      this.form.params.propertyName = ''
      this.form.params.compareType = ''
      this.form.params.compareValue = ''
      this.localForm.compareValue = ''
    },
    productTypeChange (productKey) {
      this.form.params.deviceName = ''
      this.form.params.propertyName = ''
      this.form.params.compareType = ''
      this.form.params.compareValue = ''
      this.localForm.compareValue = ''
      deviceList({ productKey }).then(res => {
        this.options3 = res.data
      })
    },
    productChange (deviceName) {
      this.form.params.propertyName = ''
      this.form.params.compareType = ''
      this.form.params.compareValue = ''
      this.localForm.compareValue = ''
      const product = this.options3.filter(item => {
        return item.deviceName === deviceName
      })[0]
      getProductProp({ productKey: product.productKey }).then(res => {
        this.options4 = res.data.thingModel.properties
      })
    },
    propChange (value) {
      this.form.params.compareType = ''
      this.form.params.compareValue = ''
      this.localForm.compareValue = ''
      const item = this.options4.filter(item => {
        return item.identifier === value
      })[0]
      const type = item.dataType.type
      if (type === 'bool' || type === 'enum') {
        this.options5 = [{
          value: '==',
          label: '=='
        }]
        const specs = item.dataType.specs
        const keys = Object.keys(specs)
        this.options6 = keys.map(index => {
          return {
            label: specs[index],
            value: index
          }
        })
        this.compareType = 0
      } else {
        this.compareType = 1
        compareRange = item.dataType.specs
        this.options5 = [{
          value: '>',
          label: '>'
        }, {
          value: '>=',
          label: '>='
        }, {
          value: '<=',
          label: '<='
        }, {
          value: '!=',
          label: '!='
        }, {
          value: '==',
          label: '=='
        }, {
          value: 'in',
          label: 'in'
        }, {
          value: 'between',
          label: 'between'
        }]
      }
    },
    compareChange (value) {
      compareValue = value
      this.inputDisabled = false
      this.form.params.compareValue = ''
      this.$forceUpdate()
    },
    inputChange (value) {
      this.form.params.compareValue = value
      this.$forceUpdate()
    },
    deleteItem () {
      this.$confirm('此操作将删除执行条件，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$emit('deleteItem', this.itemIndex)
        // this.$message({
        //   type: 'success',
        //   message: '删除成功!'
        // })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .triger-container {
    display: flex;
    flex-direction: row;
    align-items: start;

    .el-button {
      margin: 20px 10px;
    }
  }

  .triger {
    border-radius: 5px;
    width: 75%;
    min-width: 950px;
    margin: 10px 0;
    padding: 8px 15px;
    background-color: #efeeee;

    .slects {
      width: 900px;

      .el-form-item {
        margin-bottom: 0px;
      }

      .el-select {
        margin: 5px 0;
        margin-right: 30px;
      }

      .el-input {
        width: 200px;
      }

      .slect-top {
        display: flex;
        flex-direction: row;

        .el-form-item {
          margin-top: 5px;

          .el-input {
            margin-right: 30px;
          }
        }
      }

      .select-bottom {
        display: flex;
        flex-direction: row;

        .el-form-item {
          margin-top: 5px;
        }
      }
    }
  }
</style>
